 $(document).ready(function () {
     $('#owl-demo').owlCarousel({
         autoplay: true,
         stagePadding: 20,
         items: 4,
         itemsDesktop: [1193, 3],
         itemsDesktopSmall: [979, 3],
         loop: true,
         responsiveClass: true,
         responsive: {
             0: {
                 items: 1,
                 nav: false,
                 dots:false
             },
             500: {
                 items: 2,
                 nav: false
             },
             800: {
                 items: 3,
                 nav: false
             },
             1000: {
                 items: 4,
                 nav: false
             }
         }
     });
   
 });